import PropTypes from 'prop-types';
// @flow

import React, { Component } from 'react';
import classNames from 'classnames';
import _ from 'lodash';

export default class Step extends Component {

  static defaultProps = {
    completeColor: '#5096FF',
    defaultColor: '#E0E0E0',
    completeTitleColor: '#000',
    defaultTitleColor: '#757575',
    circleFontColor: '#FFF',
    size: 32,
    circleFontSize: 16,
    titleFontSize: 16,
    circleTop: 24,
  };

  static propTypes = {
    status: PropTypes.string,
    label: PropTypes.string,

    width: PropTypes.number.isRequired,
    completeColor: PropTypes.string,
    defaultColor: PropTypes.string,
    completeTitleColor: PropTypes.string,
    defaultTitleColor: PropTypes.string,
    circleFontColor: PropTypes.string,
    size: PropTypes.number,
    circleFontSize: PropTypes.number,
    titleFontSize: PropTypes.number,
    circleTop: PropTypes.number,
    index: PropTypes.number,
    completed: PropTypes.bool,
    first: PropTypes.bool,
    last: PropTypes.bool,

    isNext: PropTypes.bool.isRequired,
    onNextStatus: PropTypes.func.isRequired
  };


  getStyles() {
    const {
      completeColor, defaultColor, circleFontColor,
      activeTitleColor, completeTitleColor, defaultTitleColor,
      size, circleFontSize, titleFontSize,
      circleTop, titleTop, width,
    } = this.props;

    return {
      step: {
        width: `${width}%`,
        display: 'table-cell',
        position: 'relative',
        paddingTop: circleTop,
      },
      circle: {
        width: size,
        height: size,
        margin: '0 auto',
        backgroundColor: defaultColor,
        borderRadius: '50%',
        textAlign: 'center',
        padding: 1,
        fontSize: circleFontSize,
        color: circleFontColor,
        display: 'block',
      },
      completedCircle: {
        backgroundColor: completeColor,
      },
      index: {
        lineHeight: `${size + circleFontSize / 4}px`,
      },
      title: {
        fontSize: titleFontSize,
        // color: defaultTitleColor,
      },
      completedTitle: {
        color: completeTitleColor,
      },
      leftBar: {
        position: 'absolute',
        top: circleTop + size / 2,
        height: 1,
        left: 0,
        right: '50%',
        marginRight: size / 2 + 1,
      },
      rightBar: {
        position: 'absolute',
        top: circleTop + size / 2,
        height: 1,
        right: 0,
        left: '50%',
        marginLeft: size / 2 + 1,
      }
    };
  }

  renderLabel() {
    const { isNext, label, status, active, completed } = this.props;

    const styles = this.getStyles();

    const titleStyle = _.assign(
      styles.title,
      completed ? styles.completedTitle : {},
    );

    if (isNext) {
      return (
        <div
          style={titleStyle}
          className="order_status_stepper__step__title"
          onClick={() => this.props.onNextStatus(status)}
        >
          {label}
        </div>
      );
    }

    return (
      <div
        className="order_status_stepper__step__title"
        style={titleStyle}
      >
        {label}
      </div>
    );
  }

  render() {
    const { index, active, completed, first, last, isNext } = this.props;

    const styles = this.getStyles();

    const circleStyle = _.assign(
      styles.circle,
      completed ? styles.completedCircle : {},
    );

    const leftStyle = _.assign(styles.leftBar, (active || completed) ? styles.completedBar : {});
    const rightStyle = _.assign(styles.rightBar, completed ? styles.completedBar : {});

    const className = classNames(['order_status_stepper__step', {
      order_status_stepper__step__is_next: isNext,
      order_status_stepper__step__is_active: active,
      order_status_stepper__step__is_completed: completed,
    }]);

    return (
      <div style={styles.step} className={className}>

        <div style={circleStyle} className="order_status_stepper__step__circle">
          {(completed || active) &&
            // TODO: Add icon check
              <span style={styles.index}>
                <i className="fa fa-check" />
              </span>
          }
          {isNext &&
            <span style={styles.index} />
          }
        </div>

        {this.renderLabel()}

        {!first &&
          <div
            style={leftStyle}
            className="order_status_stepper__step__first"
          >
          </div>
        }
        {!last &&
          <div
            style={rightStyle}
            className="order_status_stepper__step__last"
          >
          </div>
        }
      </div>
    );
  }
}
